module.exports = __webpack_public_path__ + "static/media/xiaomi_battery_3.e095de4c.jpg";